
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --grid-cols-default:3;
  --grid-col-gap-default:1rem;
  --grid-item-min-width-default:1fr;
}

.se-grid{
  --_grid-cols:var(--grid-cols, var(--grid-cols-default));
  --_grid-col-gap:var(--grid-col-gap, var(--grid-col-gap-default));
  --_grid-row-gap:var(--grid-row-gap, var(--grid-col-gap-default));
  --_grid-item-min-width:var(--grid-item-min-width, var(--grid-item-min-width-default));

  display:grid;
  column-gap:var(--_grid-col-gap);
  row-gap:var(--_grid-row-gap);
}

@media screen and (min-width: 1024px){
  .se-grid{
    grid-template-columns:repeat(var(--_grid-cols), 1fr);
  }
}

.se-grid.fluid{
  grid-template-columns:repeat(
    auto-fit,
    minmax(min(var(--_grid-item-min-width), 100%), 1fr)
  );
}
`;